<div class="dialog-title">Contact List</div>

<div class="dialog-search">
  <mat-icon>search</mat-icon>
  <input type="text" class="form-control" placeholder="Search here ..." name="searchText" autofocus #searchInput
    [(ngModel)]="value" />
</div>

<div class="scroll-dialog-content core-list">
  <mat-selection-list [(ngModel)]="selected">
    <mat-list-option *ngFor="let lead of contactList | SearchFilter: value; ; let i=index" checkboxPosition="before"
      [disableRipple]="true" click-stop-propagation [value]="lead">
      <div fxLayout="row wrap">
        <div fxFlex matLine>
          <div class="xsTitle-f" matLine>{{lead?.fullName}}</div>
          <div class="contact-row" mat-line>
            <span class="icon-text">
              <mat-icon class="indicator-12">stay_current_portrait</mat-icon>
              <span class="download-link fs-10">{{lead.phoneNo}}</span>
            </span>
            <span class="vertical-divider desc-f"> | </span>
            <span class="icon-text">
              <mat-icon class="indicator-12">email</mat-icon>
              <span class="download-link fs-10">{{lead.email}}</span>
            </span>
          </div>
        </div>
      </div>
    </mat-list-option>
  </mat-selection-list>
</div>

<div class="dialog-buttons">
  <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
  <button mat-button color="primary" [mat-dialog-close]="false" (click)=submit()>Select</button>
</div>